import { createAsyncThunk } from "@reduxjs/toolkit";

import { type SurveyTemplate } from "@fitness-app/data-models/entities/SurveyTemplate";

import { type AsyncThunkCreator } from "../../../index";
import { SURVEYS_TEMPLATES_REDUCER_NAME } from "../types";

type Payload = {
  surveyTemplate: SurveyTemplate;
};

export const addSurveyTemplate = createAsyncThunk<SurveyTemplate, Payload, AsyncThunkCreator<string>>(
  `${SURVEYS_TEMPLATES_REDUCER_NAME}/addSurveyTemplate`,
  async (payload, { rejectWithValue, extra: { db, analytics } }) => {
    const { error, data } = await db
      .from("survey_template")
      .insert(payload.surveyTemplate)
      .select()
      .single<SurveyTemplate>();

    if (error) {
      return rejectWithValue(error.message);
    }

    analytics.track("add_survey_template");

    return data;
  },
);
